import styled, { css } from "styled-components";

import { COLORS } from "constants/colorScheme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  && .MuiFormLabel-root {
    font-size: 12px;
  }
`;

export const ControlWrapper = styled.div`
  width: 100%;

  position: relative;
`;

export const EditorFieldContainer = styled.div`
  margin-top: 4px;
  width: 100%;

  font-family: "Roboto";
  font-size: 16px;

  outline: none;

  border-radius: 4px;
  background-color: transparent;
  color: ${COLORS.FONT_DARK};

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.4;
    `}

  ${({ hasError }: { hasError?: boolean }) =>
    hasError
      ? css`
          border: solid 1px ${COLORS.RED};
        `
      : css`
          border: solid 1px ${COLORS.BLACK_25};
        `};

  &::placeholder {
    color: rgba(51, 51, 51, 0.4);
  }
`;

export const Wrapper = styled.div`
  margin-bottom: -40px;

  && {
    .ql-toolbar {
      padding: 4px 0;
    }

    .ql-editor {
      min-height: 148px;
      padding: 16px;
    }

    .ql-editor p {
      font-size: 16px !important;
    }

    .ql-editor.ql-blank {
      font-family: "Roboto";
      font-size: 16px;
    }

    .ql-editor.ql-blank::before {
      left: 16px;
      font-style: normal;
      color: rgba(51, 51, 51, 0.4);
    }

    .ql-container {
      border: 0;
    }
  }
`;
